import { Component, ElementRef, Input, NgZone, ViewChild, effect, inject, untracked } from '@angular/core';
import { Control, Zoom } from 'ol/control';
import { Map } from 'ol';
import { always } from 'ol/events/condition';
import { DragZoom } from 'ol/interaction';
import { CommonModule } from '@angular/common';
import { TooltipDirective } from 'src/app/shared/directives/tooltip/tooltip.directive';
import { SidebarService } from '../../features/sidebar/data-access/sidebar.service';
import { DragZoomWithPadding } from './dragZoomExtended';
import { toSignal } from '@angular/core/rxjs-interop';

@Component({
    selector: 'map-zoom-area',
    templateUrl: './zoom-area.component.html',
    styleUrls: ['./zoom-area.component.css'],
    imports: [CommonModule, TooltipDirective]
})
export class ZoomAreaComponent {
  sidebar = inject(SidebarService);


  sidebarOpen = toSignal(this.sidebar.opened$, {initialValue: false});
  sidebarWidth = toSignal(this.sidebar.drawerWidth$, {initialValue: 0});

  @Input() map: Map;

  @ViewChild('zoomAreaButton', { static: true }) zoomAreaButton: ElementRef;

  control: Control;
  interaction =  new DragZoomWithPadding({
    condition: always,
  });

  active: boolean = false;

  constructor(private elRef: ElementRef, private zone: NgZone) {

    effect(() => {
      console.log(`sidebar width: ${this.sidebarWidth()}`)
    })

  effect(() => {
    const sidebarOpen = this.sidebarOpen();

    untracked(() =>{
      const sidebarWidth = this.sidebarWidth();

      const padding: [number, number,number,number] = sidebarOpen ? [60, sidebarWidth, 60, 20] : [20,20,20,20];

      this.interaction.setPadding(padding)

    })




  })

  }

  ngOnInit(): void {}

  ngAfterViewInit(): void {
    this.interaction.setActive(this.active);

    this.control = new Control({
      target: this.elRef.nativeElement.parentNode,
      element: this.elRef.nativeElement,
    });

    this.interaction.on('boxend', () => {
      this.zone.run(() => {
        this.active = false;
        this.interaction.setActive(false);
      });
    });

    this.map.addInteraction(this.interaction);
    this.map.addControl(this.control);
  }

  toggle() {
    this.active = !this.active;
    this.interaction.setActive(this.active);
  }

  ngOnDestroy(): void {
    if (this.control == null) return;

    this.map.removeInteraction(this.interaction);
    this.map.removeControl(this.control);
  }
}
